import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import { paths } from "../../config/router.config";
import { lab4services } from "../../services/wsclients/lab4services";
import { getCurrency, logOut, setPaymentLinkInfo } from "../../utils/commons";
import ProcessFormView from "../register/ProcessFormView";
import PaymentLinkView from "./PaymentLinkView";
import { connection } from "../../config";
import wsclients from "../../services/wsclients";

export default function PaymentLinkController(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const [showLoading, onShowLoading] = useState(false);
    const [showMainLoading, onShowMainLoading] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState({});
    const [message, setMessage] = useState({});
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [confirm, setConfirm] = useState({});
    const [isContinueOrder, setIsContinueOrder] = useState(false);

    useEffect(() => {
        var url = new URL(window.location.href);
        let contact_code = null;
        if(url.pathname && url.pathname.includes("/vumatel/sms/paymentlink/")){
            let strPathName = url.pathname.split("/vumatel/sms/paymentlink/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                contact_code = strPathName[1];
               onLoadPaymentInfo(contact_code);
            }
        } else if(url.pathname && url.pathname.includes("/openserve/sms/paymentlink/")){
            let strPathName = url.pathname.split("/openserve/sms/paymentlink/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                contact_code = strPathName[1];
               onLoadPaymentInfo(contact_code);
            }
        } else if(url.pathname && url.pathname.includes("/octotel/sms/paymentlink/")){
            let strPathName = url.pathname.split("/octotel/sms/paymentlink/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                contact_code = strPathName[1];
               onLoadPaymentInfo(contact_code);
            }
        } else if(url.pathname && url.pathname.includes("/metrofibre/sms/paymentlink/")){
            let strPathName = url.pathname.split("/metrofibre/sms/paymentlink/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                contact_code = strPathName[1];
               onLoadPaymentInfo(contact_code);
            }
        }
    }, []);

    const onLoadPaymentInfo = async (contact_code) => {
        onShowLoading(true)
        try {
            let _paymentInfo = null;
            let result;
            if (connection.newApiFlow) result = await lab4services.getPaymentInfoV2(contact_code);
            else result = await lab4services.getPaymentInfoV2(contact_code);
            console.log("AAAA getPaymentInfoV2 result: ", result);
            if(result.code == 'OK'){
                if(result.data && result.data.crm_order_id) _paymentInfo = result.data;         
            }
            let newApiFlow = connection.newApiFlow;
            if (newApiFlow) {
                let topupInfoResult = await wsclients.paygateservices.getTopupInfo({
                    body: {
                        contact_id: _paymentInfo.contact_id,
                        crm_order_id: _paymentInfo.crm_order_id,
                        organisation: 'lab4',
                    },
                    url: connection.urlPaygate + "/paygate/topup_info",
                    apikey: connection.apiKeyPaygate
                })
                console.log("AAAA topupInfoResult: ", topupInfoResult)
                if (topupInfoResult.code == 'OK' && topupInfoResult.data && topupInfoResult.data.crm_order_id) {
                    setIsContinueOrder(true)
                } else setIsContinueOrder(false)
            } else setIsContinueOrder(false)
            setPaymentInfo(_paymentInfo);
        } catch (ex) {
            console.log("AAAA onLoadPaymentInfo exception: ", ex);
        }
        onShowLoading(false);
    }

    const onLogin = () => {
        history.push(paths.login);
    }

    const onCancelOrder = async () => {
        try {
            // debugger;
            let result = await lab4services.cancelOrderV2(paymentInfo);
            console.log("AAAA cancelOrder result: ", result);
            if(result.code == 'OK'){
                showMessage(true, t('CANCEL_ORDER_SUCCESS'), () => {
                    // history.push(paths.landing_page);
                    window.location.href = `${window.location.origin}${paths.landing_page}`
                });
            } else {
                showMessage(true, t('CANCEL_ORDER_FAILED'));
                return false;
            }
        } catch (ex) {
            console.log("AAAA onCancelOrder exception: ", ex)
        }
    }
 
    const showMessage = async (status, message, onClose) => {
        onShowLoading(false);
        onShowMainLoading(false);
        setMessage({
            show: status,
            content: message ? message : null,
            action: onClose,
        });
    }

    const onContinuePayment = async () => {
        onShowMainLoading(true);
        try {
            let isAllowLocation = await onCheckLocation(paymentInfo);
            if (!isAllowLocation) return false;
            let body = {
                contact_id: paymentInfo.contact_id ? paymentInfo.contact_id : null,
                email_address: paymentInfo.email_address ? paymentInfo.email_address : null,
                contact_code: paymentInfo.contact_code ? paymentInfo.contact_code : null,
                amount: paymentInfo.order_amount ? paymentInfo.order_amount : null,
                crm_order_id: paymentInfo.crm_order_id ? paymentInfo.crm_order_id : null,
            };
            // debugger;
            let result;
            if (connection.newApiFlow) result = await lab4services.initTopup(body);
            else result = await lab4services.initPayment(body);
            console.log("AAAA initPayment result: ", result);
            if (result.code == 'OK') {
                let urlFormPaygate = document._portalConfig.urlFormPaygate;
                if (result && result.code === 'OK' && result.data && result.data.client_token) {
                    let clientToken = result.data.client_token;
                    var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                    console.log('splitToken:', splitToken);
                    if (splitToken.length > 0) {
                        var payRequestIDRes = splitToken[0];
                        var checkSumRes = splitToken[1];
                        var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                            + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                            + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                            + '</form>'
                        console.log('htmlContent:', htmlContent);
                        setPaymentLinkInfo(paymentInfo);
                        setHtmlContent(htmlContent);
                        setOpenProcessForm(true);
                    }
                } else if (result.data && result.data.state === 'REJECTED') {
                    showMessage({
                        show: true,
                        message: t('INIT_PAYMENT_REJECTED'),
                        isConfirm: true,
                        confirmAction: {
                            okTitle: t('btn_try'),
                            okAction: async () => {
                                await onContinuePayment()
                            },
                            cancelTitle: t('btn_close'),
                            cancelAction: () => {
                                setMessage({})
                            }
                        }
                    });
                }
            }
        } catch (ex) {
            console.log("AAAA onContinuePayment exception: ", ex);
        }
        onShowMainLoading(false);
    }

    const onCheckLocation = async (payment_info) => {
        let isAllowLocation = false;
        try {
            let locationRef = '';
            if(payment_info.location_id) locationRef = payment_info.location_id;
            else if(payment_info.location_reference) locationRef = payment_info.location_reference;
            let queryParams = {
                locationId: locationRef,
                openserve_ref_isp: payment_info.provider_location_reference
            }
            if (payment_info.product_type == 'octotel') {
                let latLongstr = payment_info.octotel_lat_lon ? payment_info.octotel_lat_lon.split(';') : null;
                if (latLongstr && latLongstr.length > 0) {
                    queryParams = {
                        lat: latLongstr[0],
                        lng: latLongstr[1],
                        uuid: payment_info.octotel_uuid
                    }
                }
            }
            if (payment_info.product_type == 'metrofibre') {
                queryParams = {
                    metrofibre_ref_isp: payment_info.provider_location_reference,
                }
            }
            let result = await lab4services.checkLocationAvaibleOrderV3(queryParams);
            console.log("AAAA onCheckLocation result: ", result);
            if (result.code == 'OK') {
                if (result.data && result.data.is_available_create_order) {
                    isAllowLocation = true;
                }
                else if(result.data && result.data.is_availabe_create_openserve_order) {
                    let _openserveProducts = result.data.openserve_services ? result.data.openserve_services : [];
                    isAllowLocation = onCheckProductsOpenserve(_openserveProducts, payment_info.product_code);
                }
                else if (result.data && result.data.octotel_services && result.data.octotel_services.length > 0) {
                    isAllowLocation = onCheckProductsOctotel(result.data.octotel_services, payment_info.product_code);
                }
                else if (payment_info.product_type == 'metrofibre') {
                    if (result.data && result.data.is_available_create_order_metrofibre) {
                        isAllowLocation = true;
                    } else {
                        isAllowLocation = false;
                    }
                }
                else {
                    showMessage(true, t('address_used'));
                    // setMessage({
                    //     show: true,
                    //     content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                    // });
                    isAllowLocation = false;
                }
            }
        } catch (ex) {
            console.log("AAAA onCheckLocation exception: ", ex);
        }
        if(!isAllowLocation) {
            showMessage(true, t('address_used'));
        }
        return isAllowLocation;
    }

    const onCheckProductsOpenserve = (openserveServices, sku) => {
        let isCheck = false;
        try {
            if(openserveServices && openserveServices.length > 0 && sku) {
                for (let i = 0; i < openserveServices.length; i++) {
                    const item = openserveServices[i];
                    if(sku.includes(item.ProductCode + '-')) {
                        isCheck = true;
                        break;
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onCheckProductsOpenserve error: ", error);            
        }
        console.log("AAAA onCheckProductsOpenserve isCheck: ", isCheck)
        return isCheck;
    }
    
    const onCheckProductsOctotel = (octotelServices, sku) => {
        let isCheck = false;
        try {
            if(octotelServices && octotelServices.length > 0 && sku) {
                for (let i = 0; i < octotelServices.length; i++) {
                    const item = octotelServices[i];
                    if(sku.includes(item.productCode)) {
                        isCheck = true;
                        break;
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onCheckProductsOctotel error: ", error);            
        }
        console.log("AAAA onCheckProductsOctotel isCheck: ", isCheck)
        return isCheck;
    }
    
    const onContinueOrder = async () => {
        onShowLoading(true)
        setMessage({})
        try {
            let result = await lab4services.makeOrder(paymentInfo);
            console.log("AAAA createOrder result: ", result);
            if (result.code == 'OK') {
                let message = t('CREATE_ORDRER_SUCCESS');
                if (result.data && result.data.access_token) {
                    message = t('contact_existing_warning')
                }
                onShowMessage({
                    status: true,
                    desc: t('CREATE_ORDER_SUCCESS'),
                    showBackLogin: true,
                })
            } else {
                let message = t('CREATE_ORDER_NOT_SUCCESS');
                if (result.code == 'CREATE_ACTIVITY_EXCEPTION') message = t('CREATE_ACTIVITY_EXCEPTION');
                if (result.code === 'VUMATEL_SERVER_ERROR') message = t('VUMATEL_SERVER_ERROR');
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                if (entityError) {
                    message = entityError && entityError.detail && typeof (entityError.detail) === 'string' && !entityError.detail.includes('Failed to create prepaid order:') ? entityError.detail : t('CREATE_ORDER_NOT_SUCCESS');
                }
                onShowMessage({
                    status: true,
                    message: message,
                    isConfirm: true,
                    confirmAction: {
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        okAction: async () => {
                            await onContinueOrder(paymentInfo);
                        },
                        cancelAction: () => {
                            logOut();
                            history.push(paths.landing_page)
                        },
                    }
                });
            }
        } catch (ex) {
            console.log("AAAA createVumatelOrderVumaCore exception: ", ex);
        }
        onShowLoading(false)
    }

    const onShowMessage = async ({ status, message, confirmAction, isConfirm, action }) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null,
            confirmAction: confirmAction,
            isConfirm: isConfirm,
            action: action,
        });
    }

    return (
        <>
            <PaymentLinkView
                paymentInfo={paymentInfo}
                message={message}
                showLoading={showLoading}
                isContinueOrder={isContinueOrder}
                currency={getCurrency()}
                onLogin={onLogin}
                onCancelOrder={onCancelOrder}
                onContinuePayment={onContinuePayment}
                onContinueOrder={onContinueOrder}
            />
            {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}
            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => setMessage({})}
            />}
            {showMainLoading && <CustomLoading open={showMainLoading} />}
        </>
    )
}